import React, { Fragment } from 'react';
import { IReport, IReportEntity } from '../../../state/types';
import { usePrivileges } from '../../../state/auth/index.hooks';
import { useStyles } from './Themable.hooks';
import ReportList from '../ReportList/ReportList';
import Report from '../Report';
import ReportListItem from '../ReportListItem';
import { renderImageComponent } from '../ReportListItem/utils/renderImageComponent';
import { Box } from '@material-ui/core';
import TranslationHelper from '../../../helpers/TranslationHelper';
import useCopyToClipboard from '../../../hooks/useCopyToClipboard';

interface IOwnProps {
    reports: IReport[] | null;
    addActionHandler?: (report: IReport) => void;
}

const ReportPreview = ({ reports, addActionHandler }: IOwnProps) => {
    const { copyTooltip, copyLink } = useCopyToClipboard();

    const classes = useStyles();

    const privileges = usePrivileges();

    const renderListItem = (
        report: IReport,
        entity: IReportEntity,
        openDeletionDialog: any,
        borderless?: boolean
    ) => {
        return (
            <ReportListItem
                report={report}
                key={entity.id}
                entity={entity}
                handleDelete={openDeletionDialog}
                copyToClipboardHandler={{
                    action: (id, value) => copyLink(id, value),
                    label: () => copyTooltip[entity.id] || 'Copy',
                }}
                renderImageComponent={() =>
                    renderImageComponent(entity, classes, privileges)
                }
                borderless={borderless}
            />
        );
    };

    if (!reports) {
        return (
            <Box sx={{ p: 3 }}>
                <p>{TranslationHelper.translate('No data to display')}</p>
            </Box>
        );
    }

    return (
        <>
            {reports.map((report, index) => (
                <Fragment key={index}>
                    <Report
                        report={report}
                        renderReportList={({
                            open,
                            handleExpandClick,
                            openDeletionDialog,
                        }) => (
                            <ReportList
                                open={open}
                                handleExpandClick={handleExpandClick}
                                report={report}
                                openDeletionDialog={openDeletionDialog}
                                renderListItem={(
                                    entity,
                                    openDeletionDialog,
                                    borderless
                                ) =>
                                    renderListItem(
                                        report,
                                        entity,
                                        openDeletionDialog,
                                        borderless
                                    )
                                }
                                addActionHandler={() =>
                                    addActionHandler && addActionHandler(report)
                                }
                            />
                        )}
                    />
                </Fragment>
            ))}
        </>
    );
};

export default ReportPreview;
